// hooks/useApplicationData.js
import axios from 'axios'
import { useDispatch } from 'react-redux'
import {
  setAppetiteData,
  selectedApplicationData,
  setTotalApplications
} from '../store/ApplicationSlice'
import { useNavigate } from 'react-router-dom'

const useApplicationData = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const fetchApplicationData = async (
    accessToken,
    refreshToken,
    page = 1,
    limit = 15
  ) => {
    const skip = (page - 1) * limit // Calculate skip value

    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    }

    try {
      const response = await axios.get(
        `https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/intake/applications/v2/?skip=${skip}&limit=${limit}`,
        { headers }
      )
      dispatch(setAppetiteData(response.data))
      dispatch(selectedApplicationData(response.data[0]))
    } catch (error) {
      navigate('/')
    }
  }

  const fetchTotalApplicationsCount = async (accessToken, refreshToken) => {
    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    }

    try {
      const response = await axios.get(
        'https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/intake/applications/v2/total_applications',
        { headers }
      )
      dispatch(setTotalApplications(response.data.total))
    } catch (error) {
      navigate('/')
    }
  }

  return { fetchApplicationData, fetchTotalApplicationsCount }
}

export default useApplicationData
